import {getAxiosInstance, rethrowErrorWithMessage} from '../helpers/axios-helper'
import {formatMapsForFront, formatMapInfoForFront} from '../helpers/maps-helper'

const baseUrl = process.env.BACKEND_URL

function getMaps() {
  return getAxiosInstance().get(`${baseUrl}/maps`)
    .then(mapData => {
      return formatMapsForFront(mapData.data)
    })
    .catch(err => {
      console.error(err)
      throw err
    })
}

function getFullMaps() {
  return getAxiosInstance().get(`${baseUrl}/maps`)
    .then(mapData => {
      return mapData.data
    })
    .catch(err => {
      console.error(err)
      throw err
    })
}

function createMap(map) {
  return getAxiosInstance().post(`${baseUrl}/maps/`, map)
    .then(mapResult => {
      console.log(`Map ${map.name} created`)
      return {
        data: mapResult.data
      }
    })
    .catch(err => {
      console.log(err)
      throw new Error('Please ensure you have provided all required information')
    })
}

function deleteMap(mapId) {
  return getAxiosInstance().delete(`${baseUrl}/maps/${mapId}`)
    .then((data) => data)
    .catch(err => {
      if (err.response.status === 403) {
        throw new Error(err.response.data.message)
      } else {
        throw new Error('Sorry we are unable to serve your request :(')
      }
    })
}

function getMapInfos(mapId) {
  return getAxiosInstance().get(`${baseUrl}/maps/${mapId}/infos`)
    .then(mapData => {
      return formatMapInfoForFront(mapData.data)
    })
    .catch(err => {
      console.error(err)
      throw err
    })
}

function updateImage(mapId, logoBase64) {
  return getAxiosInstance().post(`${baseUrl}/maps/${mapId}/updateImage`, {
    logoBase64,
  })
        .then(gameCreated => {
          console.log('updateImage called')
          return gameCreated.data
        })
        .catch(err => {
          rethrowErrorWithMessage(err)
        })
}

export default {
  getMaps,
  getFullMaps,
  createMap,
  deleteMap,
  getMapInfos,
  updateImage
}
